// extracted by mini-css-extract-plugin
export default {"backTop":"BackTop_backTop__BUKzu","topIcon":"BackTop_topIcon__xgNns"};